import { render } from "./RegistrationCompanyGeneralTabComponent.vue?vue&type=template&id=afe49e68&scoped=true"
import script from "./RegistrationCompanyGeneralTabComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationCompanyGeneralTabComponent.vue?vue&type=script&lang=js"

import "./RegistrationCompanyGeneralTabComponent.vue?vue&type=style&index=0&id=afe49e68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe49e68"]])

export default __exports__